const actionTypeIdentifier = '5B796C54-163D-455B-9F8E-4FB2C39DF21A';

export const getOutputConfigurationDropdownlist = `GET-OUTPUT-CONFIGURATION-DROPDOWNLIST-${actionTypeIdentifier}`;
export const filterOperatorByType = `FILTER-OPERATOR-BY-TYPE-${actionTypeIdentifier}`;
export const addOutputScopeCircuit = `ADD-OUTPUT-SCOPE-CIRCUIT-${actionTypeIdentifier}`;
export const addOutputScopeEquipment = `ADD-OUTPUT-SCOPE-EQUIPMENT-${actionTypeIdentifier}`;
export const addOutputScopeOtc = `ADD-OUTPUT-SCOPE-OTC-${actionTypeIdentifier}`;
export const deleteOutputScopeData = `DELETE-OUTPUT-SCOPE-DATA-${actionTypeIdentifier}`;
export const addUpdateScopeItem = `ADD-UPDATE-OUTPUT-SCOPE-ITEM-${actionTypeIdentifier}`;
export const resetDataTable = `RESET-DATA-TABLE${actionTypeIdentifier}`
export const getOutputConfigurationDetails = `GET-OUTPUT-CONFIGURATION-DETAILS-${actionTypeIdentifier}`;
export const addUpdateOutputColumnItem = `ADD-UPDATE-OUTPUT-COLUMN-ITEM-${actionTypeIdentifier}`;
export const deleteOutputColumnData = `DELETE-OUTPUT-COLUMN-DATA-${actionTypeIdentifier}`;
export const filterColumnFormatByType = `FILTER-COLUMN-FORMAT-BY-TYPE-${actionTypeIdentifier}`;
export const updateOutputColumnsDatatable = `UPDATE-OUTPUT-COLUMN-DATA-${actionTypeIdentifier}`;
export const filterMultipleColumn1FormatByType = `FILTER-MULTIPLE-COLUMN-1-FORMAT-BY-TYPE-${actionTypeIdentifier}`;
export const filterMultipleColumn2FormatByType = `FILTER-MULTIPLE-COLUMN-2-FORMAT-BY-TYPE-${actionTypeIdentifier}`;
export const filterMultipleColumn3FormatByType = `FILTER-MULTIPLE-COLUMN-3-FORMAT-BY-TYPE-${actionTypeIdentifier}`;
export const getUpdateOutputScopeCount = `UPDATE-OUTPUT-SCOPE-COUNT-${actionTypeIdentifier}`

export const outputConfigurationModel = {
    outputConfigurationId: 0
    , configurationNumber: ''
    , configurationName: ''
    , fileName: ''
    , fileFormatId: 0
    , fileDelimeter: ''
    , isGenerateJsonFile: false
    , currencyId: 0
}

export const circuitOutputScopeModel = {
    ID: -1
    , FilterID: 0
    , OperatorID: 0
    , Value: ''
    , DateValue: null
    , StartDateValue: null
    , EndDateValue: null
    , OptionID: 0
}

export const equipmentOutputScopeModel = {
    ID: -1
    , FilterID: 0
    , OperatorID: 0
    , Value: ''
    , DateValue: null
    , StartDateValue: null
    , EndDateValue: null
    , OptionID: 0
}

export const otcOutputScopeModel = {
    ID: -1
    , FilterID: 0
    , OperatorID: 0
    , Value: ''
    , DateValue: null
    , StartDateValue: null
    , EndDateValue: null
    , OptionID: 0
}

export const outputColumnScopeModel = {
    ID: -1
    , OutputColumnScopeCircuitId: 0
    , ColumnSourceID: 0
    , ColumnName: ''
    , ColumnFormatID: 0
    , Values: ''
    , SortOrder: 0
}

export const multipleOutputColumnScopeModel = {
    ID: -1
    , OutputColumnScopeCircuitId: 0
    , ColumnSourceID1: 0
    , ColumnFormatID1: 0
    , ColumnSourceID2: 0
    , ColumnFormatID2: 0
    , ColumnSourceID3: 0
    , ColumnFormatID3: 0
    , ColumnName: ''
    , Values: ''
}

export const outputConfigurationDropdownListModel = {
    FileFormat: []
    , Currency: []
    , CircuitColumnSource: []
    , EquipmentColumnSource: []
    , OtcColumnSource: []
    , OutputColumnSource: []
    , OutputMultipleColumnSource: []
    , SearchOperator: []
    , ConditionalOption: []
    , ColumnFormat: []
    , GenerateJsonFile: []
}